/* src/app/forms/products-download/products-download.component.scss */
b {
  margin-right: 12px;
}
.content {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.view-component {
  border: 1px solid rgba(0, 0, 0, 0.03);
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.24), 0 0 2px rgba(0, 0, 0, 0.12);
  margin: 0px;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.mat-mdc-raised-button {
  padding: 0 15px;
  font-size: 0.8em;
  line-height: 24px !important;
}
.title {
  width: 100%;
  padding: 6px;
  text-align: right;
  font-size: 100%;
}
.radio {
  padding-top: 5px;
  padding-right: 5px;
}
.vl {
  border-left: 1px solid gray;
  height: 100%;
  margin: 0 5px;
}
.mat-mdc-form-field {
  width: 100%;
}
.mat-icon {
  padding-top: 2px;
  padding-right: 30px;
}
summary {
  font-weight: bold;
  margin: -0.5em -0.5em 0;
  padding: 0.5em;
}
summary:before {
  content: "";
  border-width: 0.4rem;
  border-style: solid;
  border-color: transparent transparent transparent #fff;
  position: absolute;
  top: 1.3rem;
  left: 1rem;
  transform: rotate(0);
  transform-origin: 0.2rem 50%;
  transition: 0.25s transform ease;
}
.buttonLayout {
  margin-top: 12px;
}
.buttonLayoutSave {
  margin-top: 12px;
  float: right;
}
.lista {
  margin: 15px;
}
.main {
  display: flex;
  flex-direction: row;
  width: 100%;
  max-height: 32px;
  height: 100%;
}
.main .field {
  padding-right: 6px;
  width: 100%;
  flex-basis: 90%;
}
.buttonicon {
  flex-basis: 10%;
  margin-top: 5px;
  width: 100%;
}
.company {
  padding-right: 6px;
  width: 100%;
  flex-basis: 30%;
}
.melicontainer {
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
  overflow: auto;
}
.melicontainer .left-change-mode {
  height: 100%;
  padding: 10px;
  float: left;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.melicontainer .left {
  height: 100%;
  padding: 10px;
  float: left;
  width: 70%;
  display: flex;
  flex-direction: column;
}
.melicontainer .right {
  padding: 10px;
  float: right;
  width: 30%;
  height: 100%;
  border: 1px solid #f1f2f4;
  display: flex;
  flex-direction: column;
}
.accordion-panel-filter {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.accordion-panel-filter .body {
  overflow: auto;
  height: 100%;
}
.accordion-panel-order {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.accordion-panel-order .body {
  overflow: auto;
  height: 100%;
}
.top {
  display: flex;
  height: 70%;
  flex-direction: column;
}
.action-button {
  display: flex;
  flex-direction: row;
}
.action-button span {
  margin: 0 3px;
}
.bottom {
  display: flex;
  height: 30%;
  flex-direction: column;
}
.information {
  width: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 20px;
  border-radius: 6px;
  border: 1px solid #f1f2f4;
  display: flex;
  flex-direction: row;
  max-height: 40%;
}
.information .inf {
  flex-grow: 1;
  align-self: center;
}
.information .inf span {
  font-weight: 600;
}
.itemselected {
  color: red;
}
.detail {
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: auto;
}
.cards {
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: auto;
}
.headers-align .mat-expansion-panel-header-description {
  justify-content: space-between;
  align-items: center;
}
mat-card-title {
  display: flex;
  flex-direction: row;
  font-size: 100%;
}
mat-card-subtitle {
  font-size: 100%;
}
.image {
  display: flex;
  width: 10%;
}
.title-product {
  width: 100%;
  padding: 6px;
  text-align: right;
  font-size: 100%;
  max-height: 60px;
  min-height: 60px;
  text-overflow: ellipsis;
  display: -webkit-box-orient;
  overflow: hidden;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
::ng-deep .mat-form-field-flex > .mat-form-field-infix {
  padding: 0.4em 0px !important;
}
::ng-deep .mat-form-field-label-wrapper {
  top: -1.5em;
}
::ng-deep .mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {
  transform: translateY(-1.1em) scale(0.75);
  width: 133.33333%;
}
/*# sourceMappingURL=products-download.component.css.map */
